import { FC, ReactNode } from 'react'
import * as styles from 'components/features/socialFeed/SocialProfileHeader/SocialProfileHeader.styl'
import { SocialProfileStep } from 'interfaces/feed'

const COPIES_BY_STEP: Record<SocialProfileStep, { header: ReactNode, subheader: ReactNode }> = {
  form: {
    header: <span>Choose a nickname<br />to get started</span>,
    subheader: <span>Your nickname will be visible<br />to others when you post.</span>,
  },
  confirmation: {
    header: <span>Success! You're ready<br />to start posting.</span>,
    subheader: <span>Here's how your profile will<br />appear to others.</span>,
  },
  cropper: {
    header: <span>Adjust profile picture</span>,
    subheader: undefined,
  },
}

type SocialProfileHeaderProps = {
  step: SocialProfileStep
}

const SocialProfileHeader: FC<SocialProfileHeaderProps> = (props) => {
  const COPIES = COPIES_BY_STEP[props.step]

  return (
    <div className={ styles.socialProfileHeader }>
      <div className={ styles.header }>
        { COPIES.header }
      </div>
      <div className={ styles.subheader }>
        { COPIES.subheader }
      </div>
    </div>
  )
}

export default SocialProfileHeader
